import React, { useState, useEffect, useRef } from 'react';
import * as VKID from '@vkid/sdk';
import ReCAPTCHA from 'react-google-recaptcha';
import './AuthForm.css';

// Иконки социальных сетей
const VKIcon = () => (
  <svg width="28" height="17" viewBox="0 0 28 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.3088 1.43996C27.5068 0.783963 27.3088 0.309963 26.3748 0.309963H23.3308C22.5528 0.309963 22.1948 0.711963 21.9968 1.15596C21.9968 1.15596 20.4528 4.86396 18.2728 7.28796C17.5608 7.99596 17.2368 8.21196 16.8468 8.21196C16.6488 8.21196 16.3548 7.99596 16.3548 7.33996V1.43996C16.3548 0.663963 16.1288 0.309963 15.4848 0.309963H10.7808C10.2988 0.309963 10.0088 0.659963 10.0088 0.991963C10.0088 1.72396 11.1148 1.89596 11.2268 4.08796V8.35596C11.2268 9.33996 11.0508 9.51996 10.6608 9.51996C9.61681 9.51996 7.11481 5.79596 5.63081 1.50796C5.33281 0.659963 5.03481 0.309963 4.25281 0.309963H1.20881C0.338813 0.309963 0.166813 0.711963 0.166813 1.15596C0.166813 1.95996 1.21081 5.88396 5.01081 11.0719C7.54481 14.6119 11.0808 16.5 14.3008 16.5C16.2728 16.5 16.5108 16.0739 16.5108 15.3219V12.572C16.5108 11.704 16.6908 11.532 17.3028 11.532C17.7588 11.532 18.5428 11.748 20.3828 13.5199C22.4868 15.6239 22.8308 16.5 23.9848 16.5H27.0288C27.8988 16.5 28.3348 16.0739 28.0868 15.2319C27.8168 14.3939 26.8168 13.1839 25.4908 11.684C24.7788 10.832 23.7108 9.908 23.3868 9.452C22.9308 8.86 23.0628 8.6 23.3868 8.076C23.3868 8.076 27.1208 2.74396 27.3088 1.43996Z" fill="white"/>
  </svg>
);

const TelegramIcon = () => (
  <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.6291 0.278244L1.21006 8.84624C-0.321937 9.47024 -0.312937 10.3402 0.929063 10.7262L6.80806 12.5622L20.0321 4.30524C20.6531 3.92724 21.2181 4.12924 20.7531 4.54324L10.0311 14.2132H10.0291L10.0311 14.2142L9.64706 20.2562C10.2391 20.2562 10.4991 19.9852 10.8311 19.6652L13.6991 16.8812L19.6391 21.2132C20.7281 21.8132 21.5121 21.5012 21.7771 20.2132L25.5581 2.09424C25.9491 0.52224 24.9401 -0.199756 23.6291 0.278244Z" fill="white"/>
  </svg>
);

const GmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" aria-label="Gmail" role="img" viewBox="0 0 512 512" style={{ width: '100%', height: '100%' }}>
    <rect width="512" height="512" rx="15%" fill="#ffffff"/>
    <path d="M158 391v-142l-82-63V361q0 30 30 30" fill="#4285f4"/>
    <path d="M 154 248l102 77l102-77v-98l-102 77l-102-77" fill="#ea4335"/>
    <path d="M354 391v-142l82-63V361q0 30-30 30" fill="#34a853"/>
    <path d="M76 188l82 63v-98l-30-23c-27-21-52 0-52 26" fill="#c5221f"/>
    <path d="M436 188l-82 63v-98l30-23c27-21 52 0 52 26" fill="#fbbc04"/>
  </svg>
);

// Иконка успеха (галочка)
const SuccessIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6667 5L7.50001 14.1667L3.33334 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Иконка ошибки (крестик)
const ErrorIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Иконка закрытия
const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const AuthForm = ({ 
  onLogin, 
  onRegister, 
  onForgotPassword, 
  onSocialLogin,
  loading = false,
  error = null,
  successMessage = null,
  onClearMessages
}) => {
  const [activeTab, setActiveTab] = useState('register');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaToken, setCaptchaToken] = useState(null);
  const vkIdInitialized = useRef(false);
  const recaptchaRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Проверка капчи
    if (!captchaToken) {
      // Можно показать сообщение об ошибке
      return;
    }
    
    if (activeTab === 'login') {
      onLogin?.({ email, password, captchaToken });
    } else {
      onRegister?.({ email, password, captchaToken });
    }
    
    // Сброс капчи после отправки
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    }
  };

  const handleSocialLogin = (provider) => {
    onSocialLogin?.(provider);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    onClearMessages?.();
    // Сброс капчи при смене таба
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    }
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleCaptchaExpired = () => {
    setCaptchaToken(null);
  };

  // Инициализация VK ID SDK (только конфиг, без виджета)
  useEffect(() => {
    if (!vkIdInitialized.current) {
      try {
        const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rugoplaydonate.ru';
        
        // Инициализация конфигурации VK ID
        VKID.Config.init({
          app: 54400111, // VK App ID
          redirectUrl: `${API_BASE_URL}/auth/vk/callback`,
          responseMode: VKID.ConfigResponseMode.Callback,
          source: VKID.ConfigSource.LOWCODE,
          scope: '',
        });

        vkIdInitialized.current = true;
        console.log('[VK ID] SDK config initialized');
      } catch (err) {
        console.error('[VK ID] Config initialization error:', err);
      }
    }
  }, []);

  // Обработчик клика на кнопку VK
  const handleVKLogin = async () => {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://rugoplaydonate.ru';
    
    try {
      // Используем Auth.login() для программного открытия авторизации
      const authResult = await VKID.Auth.login();
      
      console.log('[VK ID] Auth result:', authResult);
      
      if (authResult && authResult.code) {
        // Обмениваем code на токен через backend
        const response = await fetch(`${API_BASE_URL}/auth/vk/exchange`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            code: authResult.code, 
            device_id: authResult.device_id 
          }),
        });

        const data = await response.json();
        
        if (data.success && data.access_token && data.refresh_token) {
          // Сохраняем токены и перенаправляем
          localStorage.setItem('access_token', data.access_token);
          localStorage.setItem('refresh_token', data.refresh_token);
          window.location.href = '/profile';
        } else {
          console.error('[VK ID] Auth failed:', data);
        }
      }
    } catch (err) {
      console.error('[VK ID] Login error:', err);
    }
  };

  return (
    <div className="auth-form">
      {/* Табы */}
      <div className="auth-form__tabs">
        <button
          className={`auth-form__tab ${activeTab === 'register' ? 'auth-form__tab--active' : ''}`}
          onClick={() => handleTabChange('register')}
          disabled={loading}
        >
          <span className="auth-form__tab-text">Регистрация</span>
        </button>
        <button
          className={`auth-form__tab ${activeTab === 'login' ? 'auth-form__tab--active' : ''}`}
          onClick={() => handleTabChange('login')}
          disabled={loading}
        >
          <span className="auth-form__tab-text">Войти</span>
        </button>
      </div>

      {/* Разделитель */}
      <div className="auth-form__divider" />

      {/* Сообщения */}
      {error && (
        <div className="auth-form__notification auth-form__notification--error">
          <div className="auth-form__notification-icon">
            <ErrorIcon />
          </div>
          <span className="auth-form__notification-text">{error}</span>
          <button 
            className="auth-form__notification-close" 
            onClick={onClearMessages}
            type="button"
            aria-label="Закрыть"
          >
            <CloseIcon />
          </button>
        </div>
      )}
      {successMessage && (
        <div className="auth-form__notification auth-form__notification--success">
          <div className="auth-form__notification-icon">
            <SuccessIcon />
          </div>
          <span className="auth-form__notification-text">{successMessage}</span>
          <button 
            className="auth-form__notification-close" 
            onClick={onClearMessages}
            type="button"
            aria-label="Закрыть"
          >
            <CloseIcon />
          </button>
        </div>
      )}

      {/* Социальные кнопки */}
      <div className="auth-form__social">
        <button 
          className="auth-form__social-btn auth-form__social-btn--vk"
          onClick={handleVKLogin}
          aria-label="Войти через ВКонтакте"
          disabled={loading}
          title="Войти через ВКонтакте"
        >
          <VKIcon />
        </button>
        <button 
          className="auth-form__social-btn auth-form__social-btn--telegram"
          onClick={() => handleSocialLogin('telegram')}
          aria-label="Войти через Telegram"
          disabled={loading}
          title="Войти через Telegram"
        >
          <TelegramIcon />
        </button>
        <button 
          className="auth-form__social-btn auth-form__social-btn--google"
          onClick={() => handleSocialLogin('google')}
          aria-label="Войти через Google"
          disabled={loading}
          title="Войти через Google"
        >
          <GmailIcon />
        </button>
      </div>

      {/* Разделитель "или" */}
      <div className="auth-form__or">
        <div className="auth-form__or-line" />
        <span className="auth-form__or-text">или</span>
        <div className="auth-form__or-line" />
      </div>

      {/* Форма */}
      <form className="auth-form__form" onSubmit={handleSubmit}>
        <div className="auth-form__input-group">
          <input
            type="email"
            className="auth-form__input"
            placeholder="Почта"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </div>
        <div className="auth-form__input-group">
          <input
            type="password"
            className="auth-form__input"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            disabled={loading}
          />
        </div>
        
        {/* Google reCAPTCHA */}
        <div className="auth-form__captcha">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={'6Ld5K0csAAAAAJ6vQW02ZyVbbn1L_4IusVuEbEkd'}
            onChange={handleCaptchaChange}
            onExpired={handleCaptchaExpired}
            theme="light"
          />
        </div>
        
        <button 
          type="submit" 
          className={`auth-form__submit ${loading ? 'auth-form__submit--loading' : ''}`}
          disabled={loading || !captchaToken}
        >
          {loading ? (
            <span className="auth-form__spinner" />
          ) : (
            activeTab === 'login' ? 'Войти' : 'Зарегистрироваться'
          )}
        </button>
        <button 
          type="button" 
          className="auth-form__forgot"
          onClick={onForgotPassword}
          disabled={loading || activeTab === 'register'}
        >
          Забыл пароль
        </button>
      </form>
    </div>
  );
};

export default AuthForm;
